// extracted by mini-css-extract-plugin
export default {"root":"style_root__zHeog","rootFixed":"style_rootFixed__9RyDR","btn":"style_btn__m4h-s","rightOffset":"style_rightOffset__x0pgU"};